import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('compliance');

export default {
    ...authFunctions,
};